"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Store = require("../../Store");

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _Spinner = _interopRequireDefault(require("@airasia/phoenix-components/components/Spinner"));

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _cookieResetter = _interopRequireDefault(require("@airasia/phoenix-common/common/cookieResetter"));

var _constant = require("@airasia/phoenix-components/components/JourneyPriceCTA/constant");

var _buttonWrapper = _interopRequireDefault(require("./buttonWrapper.prototypes"));

var _utilities2 = require("./utilities");

var _constant2 = require("../constant");

var _utils = require("../utils");

var _funnelControlEnabledRedirection = require("../RedirectionUtility/funnelControlEnabledRedirection");

var _funnelControlDisabledRedirection = require("../RedirectionUtility/funnelControlDisabledRedirection");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ButtonWrapper = function ButtonWrapper(props) {
  var theme = props.theme,
      label = props.label,
      invertSearchButtonStyle = props.invertSearchButtonStyle,
      origin = props.origin,
      destinationValid = props.destinationValid,
      destination = props.destination,
      tripDates = props.tripDates,
      tripType = props.tripType,
      funnelServiceFlag = props.funnelServiceFlag,
      isMobile = props.isMobile,
      passengers = props.passengers,
      promoCode = props.promoCode,
      showFswCabinClass = props.showFswCabinClass,
      showTravelClass = props.showTravelClass,
      travelClass = props.travelClass,
      currency = props.currency,
      geoid = props.geoid,
      locale = props.locale,
      unifiedListingConfig = props.unifiedListingConfig,
      environment = props.environment,
      customSearchHandler = props.customSearchHandler,
      fireGtm = props.fireGtm,
      gtmParameters = props.gtmParameters,
      operatingAirline = props.operatingAirline,
      onSubmit = props.onSubmit,
      beforeRedirectHandler = props.beforeRedirectHandler,
      isEdit = props.isEdit,
      aaiRedirectionFlag = props.aaiRedirectionFlag,
      setShowAAIMessageCallback = props.setShowAAIMessageCallback,
      setAaiRedirectionUrlCallback = props.setAaiRedirectionUrlCallback,
      goToSnapToggle = props.goToSnapToggle,
      bigLoyaltyToggleValue = props.bigLoyaltyToggleValue,
      agentId = props.agentId,
      handleChinaRedirection = props.handleChinaRedirection,
      isLogin = props.isLogin,
      endpointConfig = props.endpointConfig,
      enableDataVisor = props.enableDataVisor,
      isShowSnapInNewWindow = props.isShowSnapInNewWindow,
      domain = props.domain,
      cityLevelGrouping = props.cityLevelGrouping,
      isAirasiaFlightOnly = props.isAirasiaFlightOnly,
      enableOnSearchCookieReset = props.enableOnSearchCookieReset,
      buttonId = props.buttonId;
  var baseCurrency = (0, _react.useContext)(_Store.Context).store.baseCurrency;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadingSearchButton = _useState2[0],
      isLoadingSearchButton = _useState2[1];

  var isvalidEditSearch = function isvalidEditSearch(airlineOperating, uleEnable) {
    return isEdit && (airlineOperating === _constant2.AIRLINES.OTA || uleEnable && airlineOperating === _constant2.AIRLINES.AAB);
  };

  var isAirasiaIndiaRedirection = function isAirasiaIndiaRedirection() {
    return aaiRedirectionFlag === 'true' && operatingAirline === _constant2.AIRLINES.AAI;
  };

  var redirectWIthFunnelControlService = function redirectWIthFunnelControlService(url, airlineOperating, uleEnable) {
    if (isvalidEditSearch(airlineOperating, uleEnable)) {
      onSubmit(url);
    } else if (isAirasiaIndiaRedirection()) {
      setAaiRedirectionUrlCallback(url);
      setShowAAIMessageCallback('true');
    } else {
      if (beforeRedirectHandler) beforeRedirectHandler();
      handleChinaRedirection(url);
    }
  };

  var redirectWIthoutFunnelControlService = function redirectWIthoutFunnelControlService(url) {
    if (aaiRedirectionFlag === 'true') {
      setAaiRedirectionUrlCallback(url);
      setShowAAIMessageCallback('true');
    } else if (isEdit) {
      onSubmit(url);
    } else if (operatingAirline === _constant2.AIRLINES.AAB) {
      window.open(url, '_parent');
    }

    handleChinaRedirection(url);
  };

  var redirectFromFsw = function redirectFromFsw(url) {
    var airlineOperating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant2.AIRLINES.OTA;
    var uleEnable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (enableOnSearchCookieReset) {
      var _window;

      (0, _cookieResetter.default)(((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname) || null, null, true);
    }

    if (isEdit) {
      isLoadingSearchButton(false);
    }

    if (funnelServiceFlag) {
      redirectWIthFunnelControlService(url, airlineOperating, uleEnable);
    } else {
      redirectWIthoutFunnelControlService(url);
    }
  };

  var isValidSearch = function isValidSearch() {
    return origin && destinationValid && destination && tripDates.departureDate && (tripType.toUpperCase() === _constant2.TRIP_TYPES.RETURN && tripDates.returnDate || tripType.toUpperCase() === _constant2.TRIP_TYPES.ONE_WAY);
  };

  var searchHandler = function searchHandler() {
    if (isValidSearch()) {
      isLoadingSearchButton(true);

      if (operatingAirline === _constant2.AIRLINES.AAB) {
        if (goToSnapToggle) (0, _utilities2.navigateToSNAPByCheckbox)(environment, destination, passengers, origin, tripDates, promoCode, currency, locale, isShowSnapInNewWindow);
      }

      var url;
      var isAirasiaOnlyPath = isAirasiaFlightOnly ? "&isAirasiaFlightOnly=".concat(isAirasiaFlightOnly) : '';

      if (funnelServiceFlag) {
        (0, _funnelControlEnabledRedirection.getFunnelControlEnabledRedirection)(tripType, tripDates, destination, passengers, promoCode, showTravelClass, showFswCabinClass, travelClass, currency, geoid, locale, isMobile, unifiedListingConfig, operatingAirline, origin, environment, domain, cityLevelGrouping, isEdit).then(function (result) {
          url = result && result.redirectionUrl + isAirasiaOnlyPath;
          redirectFromFsw(url, result && result.provider, result && result.enableULE);
        }).catch(function (e) {
          console.log('error calling funnelcontrol service: ', e);
        });
      } else {
        (0, _funnelControlDisabledRedirection.getFunnelControlDisabledRedirection)(operatingAirline, origin, destination, tripDates, tripType, passengers, promoCode, customSearchHandler, goToSnapToggle, bigLoyaltyToggleValue, environment, locale, currency, agentId, showTravelClass, showFswCabinClass, travelClass, aaiRedirectionFlag, isMobile, baseCurrency, isLogin, endpointConfig, enableDataVisor, isEdit).then(function (response) {
          if (response.skipRedirect) {
            isLoadingSearchButton(false);
            return;
          }

          if (operatingAirline === _constant2.AIRLINES.AAB) {
            var aaBUrl = response.url + isAirasiaOnlyPath;

            if (_utilities.default.isLocalEnvironment()) {
              aaBUrl = _constant2.LOCAL_HOST_URL + response.url + isAirasiaOnlyPath;
            }

            redirectFromFsw(aaBUrl);
          } else {
            redirectFromFsw(response);
          }
        }).catch(function (e) {
          console.log('error in getting redirection URL via provider: ', e); // fallback to airasia legacy select page when encryptdeeplink call fails

          if (operatingAirline === _constant2.AIRLINES.AAB) {
            var substitutedPathParams = (0, _utils.generateRedirectPathWithoutDeepLink)(origin, destination, tripDates, tripType, passengers, promoCode, locale, currency, environment);
            var fallbackRedirectionUrl = _constant2.ENVIRONMENT_URL[environment].AA_BASE_URL + substitutedPathParams;

            if (_utilities.default.isLocalEnvironment()) {
              fallbackRedirectionUrl = _constant2.LOCAL_HOST_URL + substitutedPathParams;
            }

            redirectFromFsw(fallbackRedirectionUrl);
          }
        });
      } // GTM push when search clicked


      (0, _utilities2.fireGtmSearch)(origin, destination, tripDates, passengers, promoCode, geoid, tripType, fireGtm, gtmParameters === null || gtmParameters === void 0 ? void 0 : gtmParameters.appName);
      (0, _utils.constructLocalStorageObject)(origin, destination, passengers, tripDates.departureDate, tripDates.returnDate, promoCode, tripType, cityLevelGrouping);
    } else {// Error Handler
    }
  };

  var isMoveTheme = theme === _constant.THEMES.MOVE;

  function getColor(invertButton, feature) {
    if (invertButton) {
      return _constant.moveSecondaryButton[isMoveTheme][feature];
    }

    return _constant.movePrimaryButton[isMoveTheme][feature];
  }

  var renderButtonComponent = function renderButtonComponent() {
    return /*#__PURE__*/_react.default.createElement("span", {
      id: "fsw-search-button-container"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      disabled: loadingSearchButton,
      defaultDisabledFeatures: false,
      backgroundColor: getColor(invertSearchButtonStyle, 'backgroundColor'),
      border: getColor(invertSearchButtonStyle, 'border'),
      color: getColor(invertSearchButtonStyle, 'color'),
      theme: theme,
      handleClick: searchHandler,
      width: "100%",
      customProperties: _objectSpread(_objectSpread({}, (0, _utilities2.setButtonCustomProperties)(loadingSearchButton)), {}, {
        'aria-label': 'Search Flights button. Actionable left click or press enter',
        id: buttonId
      })
    }, !loadingSearchButton ? label : /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      animationDuration: "0.5s",
      color: getColor(invertSearchButtonStyle, 'color'),
      height: "35px",
      show: true,
      strokeWidth: "4",
      theme: theme,
      width: "35px"
    })));
  };

  return renderButtonComponent();
};

ButtonWrapper.propTypes = _buttonWrapper.default.PropTypes;
ButtonWrapper.defaultProps = _buttonWrapper.default.DefaultProps;
var _default = ButtonWrapper;
exports.default = _default;